/**
 * Validação de destino de redirecionamento pós-login.
 *
 * O caminho vem de `?redirect=` na URL e do convite pendente no localStorage —
 * os dois são entrada não confiável. A regra antiga era `começa com "/" e não
 * começa com "//"`, que deixa passar `/\evil.com`: o navegador normaliza a
 * barra invertida para "/" e trata o valor como protocolo-relativo, saindo do
 * site. É o bypass descrito em CVE-2025-68470 / GHSA-wrjc-x8rr-h8h6 (React
 * Router), que na linha 6 não tem correção — mas o buraco aqui é nosso e
 * independe da biblioteca.
 *
 * Só passa caminho interno: barra única, sem barra invertida, sem esquema.
 */

/** Caminho seguro para onde mandar quem acabou de entrar. */
export const DEFAULT_REDIRECT = '/workspaces';

export function isSafeRedirect(path: string | null | undefined): boolean {
  if (!path) return false;
  // Precisa ser caminho absoluto interno.
  if (!path.startsWith('/')) return false;
  // "//host" e "/\host" viram protocolo-relativo no navegador.
  if (path.startsWith('//')) return false;
  // Barra invertida em qualquer posição: navegadores normalizam para "/",
  // então "/a\..\evil.com" também escapa. Caminho interno não precisa dela.
  if (path.includes('\\')) return false;
  // "/javascript:..." ou qualquer esquema embutido.
  if (/^\/+[a-z][a-z0-9+.-]*:/i.test(path)) return false;
  // Caracteres de controle são ignorados por alguns parsers de URL e permitem
  // montar valores que escapam do site.
  // eslint-disable-next-line no-control-regex
  if (/[ -]/.test(path)) return false;
  return true;
}

/** Devolve o caminho quando é seguro; senão, o destino padrão. */
export function safeRedirectOr(path: string | null | undefined, fallback = DEFAULT_REDIRECT): string {
  return isSafeRedirect(path) ? (path as string) : fallback;
}
